<template>
    <ais-instant-search
        :search-client="searchClient"
        index-name="pages"
        :routing="routing"
    >
        <AlgoliaSearchContainer
            :image="image"
            :ratio="ratio"
        />
    </ais-instant-search>
</template>
<script>
import algoliasearch from 'algoliasearch/lite';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';

function getCategorySlug(name) {
    if (!name) return;
    return name
        .toLowerCase()
        .replace('&', 'and')
        .replace(', ', '--')
        .split(' ')
        .map(encodeURIComponent)
        .join('-');
}

function getCategoryName(slug) {
    if (!slug) return;
    return slug
        .replace('--', ', ')
        .split('-')
        .map(decodeURIComponent)
        .join(' ')
        .replace('and', '&')
        .replace(/\b\w/g, function(l){ return l.toUpperCase() })
}

function getRegionSlug(name) {
    if (!name) return;
    return name
        .split(' ')
        .map(encodeURIComponent)
        .join('-');
}

function getRegionName(slug) {
    if (!slug) return;
    return slug
        .split('-')
        .map(decodeURIComponent)
        .join(' ');
}

const routing = {
    router: historyRouter({
        windowTitle({ category, query }) {
            if (query) {
                const queryTitle = `Results for "${query}"`;

                if (category) {
                    return `${category} – ${queryTitle}`;
                }

                return queryTitle;
            }
        },

        createURL({ qsModule, routeState, location }) {
            const urlParts = location.href.match(/^(.*?)\/search/);
            const baseUrl = `${urlParts ? urlParts[1] : ''}/`;

            const categoryPath = routeState.category ? `${getCategorySlug(routeState.category[0])}/` : '';

            const subCategoryPath = routeState.category && routeState.category.length > 1 ? `${getCategorySlug(routeState.category[1])}/` : '';

            const queryParameters = {};

            const locationRoute = routeState.region || routeState.surroundings;

            if (locationRoute) {
                const region = locationRoute[0].split(' > ');
                queryParameters.region = getRegionSlug(region[0]);
                queryParameters.town = getRegionSlug(region[1]);
            }

            if (routeState.query) {
                queryParameters.query = encodeURIComponent(routeState.query);
            }

            if (routeState.surroundings) {
                queryParameters.surroundings = true;
            }

            if (routeState.page !== 1) {
                queryParameters.page = routeState.page;
            }

            if (routeState.features) {
                queryParameters.features = routeState.features;
            }

            const queryString = qsModule.stringify(queryParameters, {
                addQueryPrefix: true,
                arrayFormat: 'repeat',
            });

            console.log(routeState);

            return `${baseUrl}search/${categoryPath}${subCategoryPath}${queryString}`;
        },

        parseURL({ qsModule, location }) {
            const pathnameMatches = location.pathname.match(/search\/([^/]*)\/?([^/]*)/);

            let category = getCategoryName(
                (pathnameMatches && pathnameMatches[1]) || ''
            );

            const subcategory = getCategoryName(
                (pathnameMatches && pathnameMatches[2]) || ''
            );

            if (category && subcategory) {
                category = `${category} > ${subcategory}`
            } else {
                category;
            }

            const { query = '', page, region, town, surroundings, features = [] } = qsModule.parse(
                location.search.slice(1)
            );

            const allFeatures = Array.isArray(features)
            ? features
            : [features].filter(Boolean);

            let surrounding;
            let regions;

            if (region && town) {
                if (surroundings) {
                    surrounding = [`${getRegionName(region)} > ${getRegionName(town)}`];
                    regions;
                } else {
                    regions = [`${getRegionName(region)} > ${getRegionName(town)}`];
                    surrounding;
                }
            } else {
                regions;
                surroundings;
            }

            return {
                query: decodeURIComponent(query),
                page,
                features: allFeatures.map(decodeURIComponent),
                category,
                surroundings: surrounding,
                region: regions
            };
        },
    }),

    stateMapping: {
        stateToRoute(uiState) {
            return {
                query: uiState.query,
                page: uiState.page,
                category: uiState.hierarchicalMenu && uiState.hierarchicalMenu['categories.lvl0'],
                subcategory: uiState.hierarchicalMenu && uiState.hierarchicalMenu['categories.lvl1'],
                region: uiState.refinementList && uiState.refinementList['regions.lvl1'],
                surroundings: uiState.refinementList && uiState.refinementList['surroundings.lvl1'],
                features: uiState.refinementList && uiState.refinementList['productFeatures']
            };
        },

        routeToState(routeState) {
            return {
                query: routeState.query,
                page: routeState.page,
                hierarchicalMenu: {
                    'categories.lvl0' : [routeState.category]
                },
                refinementList: {
                    'surroundings.lvl1': routeState.surroundings,
                    'regions.lvl1': routeState.region,
                    'productFeatures': routeState.features
                }
            };
        },
    },
};

export default {
    props: {
        image: {
            type: String,
            default: null
        },
        ratio: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            searchClient: algoliasearch(
                window.algoliaId,
                window.algoliaSearchKey
            ),
            routing: {
                router: routing.router,
                stateMapping: routing.stateMapping,
            }
        }
    }
}
</script>
